import { concat } from 'ramda';
import { inventoryManagementApi } from '../inventoryManagementApi';

const getUrl = concat('reconsignments/');

const reconsignmentEndpoints = inventoryManagementApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    cancelReconsignment: mutation({
      invalidatesTags: ['Reconsignments'],
      query: ({ body }) => ({
        body,
        method: 'POST',
        url: getUrl('cancel-reconsignment'),
      }),
    }),
    createOnetoManyReconsignments: mutation({
      invalidatesTags: ['Reconsignments', 'Reconsignment'],
      query: ({ body }) => ({
        body,
        method: 'POST',
        url: getUrl('create-one-many-reconsignments'),
      }),
    }),
    createReconsignment: mutation({
      invalidatesTags: ['Reconsignments', 'Reconsignment'],
      query: ({ body }) => ({
        body,
        method: 'POST',
        url: getUrl('create-reconsignment'),
      }),
    }),
    createReconsignmentSet: mutation({
      query: ({ body }) => ({
        body,
        method: 'POST',
        url: getUrl('create-reconsignment-set'),
      }),
    }),
    editReconsignment: mutation({
      invalidatesTags: ['Reconsignments', 'Reconsignment'],
      query: ({ body }) => ({
        body,
        method: 'POST',
        url: getUrl('edit-reconsignment'),
      }),
    }),
    getAffiliateProducts: query({
      invalidatesTags: ['Destination', 'Location', 'RVP'],
      providesTags: ['Product'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-affiliate-products'),
      }),
    }),
    getDestinations: query({
      providesTags: ['Destination'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-product-destinations'),
      }),
    }),
    getFilterValues: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-reconsignments-filter-values'),
      }),
    }),
    getFromLocationList: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-from-locations-list'),
      }),
    }),
    getFromLocations: query({
      providesTags: ['From Locations'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('get-from-locations-details'),
      }),
    }),
    getLocationsByLocationId: query({
      providesTags: ['Destination'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-product-destinations'),
      }),
      transformResponse: res => {
        return res.reduce((a, c) => {
          // eslint-disable-next-line no-param-reassign
          a[c.locationId] = c.locationName;

          return a;
        }, []);
      },
    }),
    getLocationsInventoryOrigins: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-location-inventory-origins'),
      }),
    }),
    getLocationsInventoryVolumes: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-location-inventory-volumes'),
      }),
    }),
    getProductBalances: query({
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-product-balances'),
      }),
    }),
    getProductOrigins: query({
      providesTags: ['Origin'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-product-origins'),
      }),
    }),
    getReconsignment: query({
      providesTags: ['Reconsignment'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('edit-reconsignment'),
      }),
    }),
    getReconsignments: query({
      providesTags: ['Reconsignments'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-reconsignments'),
      }),
    }),
    getReidVaporPressure: query({
      providesTags: ['RVP'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-product-reid-vapor-pressures'),
      }),
    }),
    getToLocations: query({
      providesTags: ['To Locations'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('get-to-locations-details'),
      }),
    }),
    getViewReconsignment: query({
      providesTags: ['Reconsignment'],
      query: ({ params }) => ({
        keepUnusedDataFor: 0,
        params,
        url: getUrl('view-reconsignment'),
      }),
    }),
  }),
});

// eslint-disable-next-line import/prefer-default-export
export const {
  useCancelReconsignmentMutation,
  useCreateOnetoManyReconsignmentsMutation,
  useCreateReconsignmentSetMutation,
  useCreateReconsignmentMutation,
  useEditReconsignmentMutation,
  useGetAffiliateProductsQuery,
  useGetFromLocationListQuery,
  useGetDestinationsQuery,
  useGetFilterValuesQuery,
  useGetFromLocationsQuery,
  useGetToLocationsQuery,
  useGetLocationsByLocationIdQuery,
  useGetLocationsInventoryOriginsQuery,
  useGetLocationsInventoryVolumesQuery,
  useGetProductBalancesQuery,
  useGetProductOriginsQuery,
  useGetReconsignmentQuery,
  useGetReidVaporPressureQuery,
  useLazyGetReconsignmentsQuery,
  useGetViewReconsignmentQuery,
} = reconsignmentEndpoints;
